import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Helmet from "react-helmet";
import { mapFocalAreaToDecimal } from "@utils";
import { useMetaData } from "@staticQueries";
import { imageProps } from "@ui";

const SEO = ({ title: _title, description: _description, image: _image }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            author
          }
        }
      }
    `
  );

  const { author } = site.siteMetadata;

  const {
    defaultMetaTitle,
    defaultMetaDescription,
    defaultMetaImage,
  } = useMetaData();

  // use passed metadata and fallback to site defaults
  const title = `${_title || defaultMetaTitle} | Civic Online Reasoning`;
  const description = _description || defaultMetaDescription;
  const image = _image || defaultMetaImage;

  // build imgix url for meta image
  const { url, fpx: _fpx, fpy: _fpy, filter: _filter } = image;

  const imageSize = "w=1200&h=630";
  const fpx = mapFocalAreaToDecimal(_fpx);
  const fpy = mapFocalAreaToDecimal(_fpy);
  let imageSrc = `${url}?${imageSize}&fp-x${fpx}&fp-y${fpy}`;

  if (_filter) {
    const filter = _filter.replace("#", "");
    imageSrc += `&duotone=${filter}%2CFFFFFF&duotone-alpha=100`;
  }

  return (
    <Helmet
      title={title}
      meta={[
        {
          name: "viewport",
          content: "width=device-width, initial-scale=1 maximum-scale=1",
        },
        {
          name: "description",
          content: description,
        },
        {
          property: "og:image",
          content: imageSrc,
        },
        {
          property: "og:title",
          content: title,
        },
        {
          property: "og:description",
          content: description,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:creator",
          content: author,
        },
        {
          name: "twitter:title",
          content: title,
        },
        {
          name: "twitter:description",
          content: description,
        },
      ]}
    >
      <link
        type="application/opensearchdescription+xml"
        rel="search"
        href="/osdd.xml"
      />
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: imageProps.props,
};

SEO.defaultProps = {
  description: "",
  image: null,
};

export default SEO;
